module.exports = __webpack_public_path__ + "static/media/bestcamp-logo-with-icon.6ba6f39f.svg";